import type { ReactNode } from 'react';
import { JOURNEY_STAGES, experimentIdFromPath, stageFromPath } from './chrome.js';
import { Link, usePathname } from './router.js';

/** Navigate by progress: the shell that an Experiment route switches to on its own. */
export function JourneyStrip({ onSignOut }: { onSignOut: () => void }): ReactNode {
  const pathname = usePathname();
  const experimentId = experimentIdFromPath(pathname);
  const current = stageFromPath(pathname);
  const currentIndex = JOURNEY_STAGES.findIndex((stage) => stage.key === current);

  return (
    <header className="journey-top">
      <div className="journey-mast">
        <Link to="/" className="brand">
          <span className="brand-mark" aria-hidden="true" />
          <span>Creative Studio</span>
        </Link>
        <div className="journey-context">
          <strong>Experiment</strong>
          <span>{experimentId ?? 'не сохранён'}</span>
        </div>
        <button className="ghost" type="button" onClick={onSignOut}>
          Выйти
        </button>
      </div>
      <nav className="journey" aria-label="Этапы Experiment">
        {JOURNEY_STAGES.map((stage, index) => (
          <Link
            key={stage.key}
            to={`/experiments/${experimentId ?? 'new'}/${stage.key}`}
            className={index < currentIndex ? 'done' : stage.key === current ? 'active' : ''}
          >
            <span className="stage-index">{String(index + 1).padStart(2, '0')}</span>
            <span>{stage.label}</span>
          </Link>
        ))}
      </nav>
    </header>
  );
}
